const KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "ttclid",
];
const STORE_KEY = "mtn_attribution";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

const readStored = () => {
    try {
        return JSON.parse(localStorage.getItem(STORE_KEY) || "null");
    } catch {
        return null;
    }
};

export const captureAttribution = () => {
    try {
        const q = new URLSearchParams(window.location.search);
        const found = {};
        KEYS.forEach((k) => {
            const v = q.get(k);
            if (v) found[k] = v;
        });
        const hasNew = Object.keys(found).length > 0;
        const stored = readStored();
        const fresh = stored && stored.ts && Date.now() - stored.ts < MAX_AGE_MS;
        if (hasNew || !fresh) {
            localStorage.setItem(
                STORE_KEY,
                JSON.stringify({ params: found, ts: Date.now() }),
            );
        }
    } catch {
        /* storage unavailable */
    }
};

export const getAttribution = () => readStored();

export const withAttribution = (base) => {
    const rec = readStored();
    if (!rec || !rec.params) return base;
    const url = new URL(base);
    Object.entries(rec.params).forEach(([k, v]) => {
        if (!url.searchParams.has(k)) url.searchParams.append(k, v);
    });
    return url.toString();
};

export const refCode = () => {
    const p = (readStored() || {}).params || {};
    const parts = [p.utm_source, p.utm_campaign].filter(Boolean);
    return parts.length ? parts.join("-") : "directo";
};

export const pushEvent = (event, data = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
    if (typeof window.gtag === "function") {
        window.gtag("event", event, data);
    }
};

export const trackCta = (event, ctaLocation) => () =>
    pushEvent(event, ctaLocation ? { cta_location: ctaLocation } : {});
